var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip0_322_2033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_322_2033",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_309_1883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8495 0.893311H0.837402V13.9054H13.8495V0.893311Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_322_2033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6716 0.893066H2.01364C1.36338 0.893066 0.836426 1.42002 0.836426 2.07029V12.7283C0.836426 13.3782 1.36338 13.9055 2.01364 13.9055H12.6716C13.3216 13.9055 13.8488 13.3785 13.8488 12.7283V2.07029C13.8488 1.42036 13.3216 0.893066 12.6716 0.893066ZM4.86302 12.1284C4.86302 12.3175 4.70973 12.4711 4.52034 12.4711H3.0621C2.87306 12.4711 2.71943 12.3178 2.71943 12.1284V6.01615C2.71943 5.82709 2.87271 5.67347 3.0621 5.67347H4.52034C4.70939 5.67347 4.86302 5.82675 4.86302 6.01615V12.1284ZM3.79139 5.09747C3.02634 5.09747 2.40605 4.47717 2.40605 3.71212C2.40605 2.94707 3.02634 2.32678 3.79139 2.32678C4.55645 2.32678 5.17673 2.94707 5.17673 3.71212C5.17673 4.47717 4.55645 5.09747 3.79139 5.09747ZM12.4829 12.156C12.4829 12.3301 12.3419 12.4711 12.1678 12.4711H10.6033C10.4292 12.4711 10.2882 12.3301 10.2882 12.156V9.28888C10.2882 8.8611 10.4136 7.41477 9.17063 7.41477C8.20626 7.41477 8.01078 8.40501 7.97161 8.8492V12.156C7.97161 12.3301 7.83059 12.4711 7.65652 12.4711H6.14311C5.96904 12.4711 5.82802 12.3301 5.82802 12.156V5.98855C5.82802 5.81449 5.96904 5.67347 6.14311 5.67347H7.65652C7.83059 5.67347 7.97161 5.81449 7.97161 5.98855V6.52164C8.32923 5.98514 8.86068 5.57094 9.99188 5.57094C12.4972 5.57094 12.4829 7.91175 12.4829 9.19765V12.156Z",
    fill: "#1E1C40"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_322_2033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.410156 0.340088)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.20e205d09782166f2db09d86addbc277.svg";
export { ForwardRef as ReactComponent };